<template>
  <div id="about">
    <h2 class="div-transparent">Naše služby</h2>
    <div class="about-services">
      <div class="service-column left">
        <div class="service">
          <div class="icon">
            <font-awesome-icon icon="truck-pickup" title="Prodej" size="2x" />
          </div>DOVOZ A PRODEJ AUTOMOBILŮ NA ZAKÁZKU
        </div>
        <div class="service">
          <div class="icon">
            <font-awesome-icon icon="car" title="Výkup" size="2x" />
          </div>VÝKUP A PRODEJ OJETÝCH AUTOMOBILŮ
        </div>
        <div class="service">
          <div class="icon">
            <font-awesome-icon icon="car" title="Výkup" size="2x" />
          </div>VÝKUP VETERÁNŮ
        </div>
        <div class="service">
          <div class="icon">
            <font-awesome-icon icon="money-bill" title="Protiúčet" size="2x" />
          </div>MOŽNÝ PRODEJ NA PROTIÚČET
        </div>
      </div>
      <div class="service-column right">
        <div class="service">
          LEASING, ÚVĚR OD SPOLEČNOSTI MONETA AUTO FINANCE
          <div class="icon">
            <font-awesome-icon icon="coins" title="Telefon" size="2x" />
          </div>
        </div>
        <div class="service">
          VYŘÍZENÍ DOKUMENTACE K PŘIHLÁŠENÍ VOZIDEL
          <div class="icon">
            <font-awesome-icon icon="folder-open" title="Dokumenty" size="2x" />
          </div>
        </div>
        <div class="service">
          POJIŠTĚNÍ KOOPERATIVA
          <div class="icon">
            <font-awesome-icon icon="umbrella" title="Dokumenty" size="2x" />
          </div>
        </div>
        <div class="service">
          PNEUSERVIS + KLIMATIZACE + AUTOSERVIS
          <div class="icon">
            <font-awesome-icon icon="tools" title="Telefon" size="2x" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import Offer from "../Offer/Offer";

export default {
  components: {
    // Offer
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../scss/global.scss";

#about {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: $default-page-background;
  z-index: 50;
  .about-services {
    width: 100%;
    position: relative;
    flex-wrap: wrap;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .service-column {
      width: 30rem;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      &.right {
        align-items: flex-end;
        .service {
          .icon {
            margin-left: 1rem;
            margin-right: 0rem;
          }
        }
      }
      .service {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        justify-items: center;
        text-align: left;
        color: $default-page-color;
        font-weight: 700;
        font-size: 0.6rem;
        margin: 0.5rem 1rem;
        .icon {
          font-size: 0.8rem;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 3rem;
          height: 3rem;
          margin-right: 1rem;
          background-color: $default-page-color;
          border-radius: 50%;
          color: #fff;
        }
      }

      @media (min-width: $min-width-extended) {
        .service {
          font-size: 0.8rem;
          .icon {
            font-size: 0.8rem;
          }
        }
      }
    }
  }
}
</style>
